import * as yup from 'yup';
import api from '@/services/api';

export const companySchema = yup.object({
  name: yup.string().required('Nombre es requerido')
    .test(
      'checkDuplicateName',
      'El Nombre ya existe',
      async function (value) {
        const { id, companyTypeId } = this.options.context || {};

        if (!value) return true; // Skip if empty — let `.required` handle it
        if (!companyTypeId) return true;
        try {
          const response = await api.get(`/company/validate-name?id=${id}&name=${value}&companyTypeId=${companyTypeId}`);

          return !response.data;
        } catch (error) {
          return this.createError({
            message: 'Error al validar el nombre de la empresa',
          });
        }
      }
    ),
  companyCategory: yup.number().nullable().required('Tipo es requerido'),
  domains: yup.string()
    .nullable()
    .transform((value) => (!value || value.trim() === '' ? null : value))
    .max(300, 'Máximo 300 caracteres')
    .test(
      'min-length',
      'Mínimo 4 caracteres',
      value => !value || value.trim().length >= 4
    )
    .test(
      'valid-domains',
      'Ingrese dominios válidos separados por coma. Ej: empresa.com,empresa.org',
      value => {
        if (!value || value.trim().length < 4) return true;
        const dominios = value.split(',')
        const regex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/
        return dominios.every(d => regex.test(d.trim()))
      }
    ),
  alias: yup.string()
    .nullable()
    .transform((value) => (!value || value.trim() === '' ? null : value))    
    .min(4, 'Mínimo 4 caracteres')
    .max(1000, 'Máximo 1000 caracteres')
    .test(
      'valid-alias',
      'Ingrese alias válidos para la empresa separados por coma. Ej: EmpresaUno,EmpresaDos.',
      value => {
        if (!value || value.trim() === '')
          return true

          return value
          .split(',')
          .every(a => a.trim().length > 0)
      }
    ),
  ruc: yup.string().required('RUC es requerido')
    .min(11, 'Mínimo 11 caracteres')
    .max(11, 'Máximo 11 caracteres')
    .test(
      'checkDuplicateRUC',
      'El RUC ya existe',
      async function (value) {
        const { id, companyTypeId } = this.options.context || {};

        if (!value) return true; // Skip if empty — let `.required` handle it
        if (!companyTypeId) return true;
        try {
          const response = await api.get(`/company/validate-ruc?id=${id}&ruc=${value}&companyTypeId=${companyTypeId}`);

          return !response.data;
        } catch (error) {
          return this.createError({
            message: 'Error al validar el RUC de la empresa',
          });
        }
      }
    ),
  description: yup.string().required('Descripción es requerido'),
  companyTypeId: yup.number().nullable().required('Tipo es requerido'),

});